var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/internal/DisplayIcon/DisplayIcon.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { IconFavoriteHome, IconPhone, IconDollarSignCircle, IconZillowLogo, token, DetailedIconKeyHome } from '@zillow/constellation';
import PACKAGE_SPECIFIED_ICONS from '../../../img';
var DEFAULT_FONT_COLOR = 'brand';

var iconCss = function iconCss(_ref) {
  var fontColor = _ref.fontColor;
  return css(["color:", ";"], token("colors." + (fontColor || DEFAULT_FONT_COLOR)));
};

export var SUPPORTED_CONSTELLATION_ICONS = {
  dollar: IconDollarSignCircle,
  home: IconFavoriteHome,
  logo: IconZillowLogo,
  phone: IconPhone,
  keyHome: DetailedIconKeyHome
};
export var DisplayIcon = styled(function (_ref2) {
  var icon = _ref2.icon,
      className = _ref2.className;
  var customizedComponents = Object.assign(Object.assign({}, SUPPORTED_CONSTELLATION_ICONS), PACKAGE_SPECIFIED_ICONS);
  var IconToBeRendered = customizedComponents[icon] || customizedComponents.logo;
  return /*#__PURE__*/React.createElement(IconToBeRendered, {
    className: className,
    size: "lg",
    role: "presentation",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 12
    }
  });
}).withConfig({
  displayName: "DisplayIcon",
  componentId: "yz4dkn-0"
})(["", ""], iconCss);
DisplayIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Icon used in your messaging.
   * Check supported icons listed in http://constellation.pages.zgtools.net/constellation-site/team-api.html#/%40zillow%2Fzrs-cms-messaging/Components?id=displayicon
   *
   * Default icon is a zillow logo.
   * */
  icon: PropTypes.string,

  /**
   * The constellation color code for the icon's drawing color.
   * Available constellation color codes could be found at
   * http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#section-colors
   */
  fontColor: PropTypes.string
} : {};
DisplayIcon.defaultProps = {
  icon: 'logo',
  fontColor: null
};
/** @component */

export default DisplayIcon;